// pages/Dashboard.jsx
import ComingSoon from "../../components/home/ComingSoon";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <ComingSoon />
    </HomeLayout>
  );
}
